export const flutterMessage = (type, message) => {
  try {
    Flutter.postMessage(type + '|' + message);
  } catch (error) {}
};
